import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Hls from "hls.js";

import './style.scss';

function VideoStreamPopup({ providerId, url, closePopup }) {
	const videoRef = useRef(null);

	useEffect(() => {
		let hls = null;
		if (Hls.isSupported() && url) {
			hls = new Hls();
			hls.loadSource(url);
			hls.attachMedia(videoRef.current);
			hls.on(Hls.Events.MANIFEST_PARSED, function () {
				videoRef.current.play();
			});
		} else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
			videoRef.current.src = url;
			videoRef.current.addEventListener("loadedmetadata", function () {
				videoRef.current.play();
			});
		}
		return () => {
			hls?.destroy?.();
		};
	}, [url]);
	if (
		parseInt(providerId) === 21 ||
		parseInt(providerId) === "22" ||
		parseInt(providerId) === "23" ||
		parseInt(providerId) === "24"
	) {
		return (
			<>
				<iframe src={url} width="100%" height="100%" frameBorder="0" scrolling="no" />
			</>
		);
	}
	return (
		<>
			<div className="video-stream-popup">
				<i onClick={closePopup} className="global-icon icon-Close close-popup" />
				<div className="preview-section">
					<video ref={videoRef} />
				</div>
			</div>
		</>
	);
}
VideoStreamPopup.propTypes = {
	videoUrl: PropTypes.string,
};
export default VideoStreamPopup;